import { getGetAssetPartsUrl } from 'generatedTypes/asset/services/asset-parts-controller';
import { useState } from 'react';

import useFetch from 'hooks/useFetch';
import useRetry from 'hooks/useRetry';

import useTranslation from './hooks/useTranslation';

import type { AssetPartsResponse, FetchAssetParts, UseAssetParts } from './types';

const useAssetParts = (): UseAssetParts => {
    const [isLoading, setIsLoading] = useState(false);
    const [assetParts, setAssetParts] = useState<AssetPartsResponse | null>(null);
    const { authenticatedGet } = useFetch();
    const { withRetry } = useRetry();
    const { CONNECTION_ERROR } = useTranslation();

    const fetchAssetParts: FetchAssetParts = async ({ assetId }) => {
        try {
            setIsLoading(true);
            const url = getGetAssetPartsUrl(assetId);

            const response = await withRetry(
                () => authenticatedGet<AssetPartsResponse>(url),
                CONNECTION_ERROR,
                () => fetchAssetParts({ assetId })
            );

            setAssetParts(response);

            return response;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        assetModelId: assetParts?.assetModelId,
        fetchAssetParts,
        isLoading,
        parts: assetParts?.parts ?? []
    };
};

export default useAssetParts;
